import { Grid, ListItemAvatar, Typography } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import React, { Fragment } from "react";
import { getCardImageByType } from "../../../../utils";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  cardLogo: {
    height: "100%",
    // marginRight: theme.spacing(3),
  },
}));

export default function PaymentDetailListingRegistered(props) {
  const classes = useStyles();
  const { name = "", nickName = "", cardType = "" } = props.values;
  return (
    <Fragment>
      <List className={classes.root} dense>
        <Grid container>
          {/* <Grid item xs={12}>
            <ListItem>
              <ListItemText
                primary="Name on Card"
                secondary={
                  <Typography variant="h6" color="secondary">
                    {name}
                  </Typography>
                }
              />
            </ListItem>
          </Grid> */}
          <Grid item xs={12}>
            <Divider />
            <ListItem>
              <ListItemText
                primary="Card Type"
                secondary={
                  <Typography variant="h6" color="secondary">
                    {cardType} 
                  </Typography>
                }
              />
              <ListItemAvatar>
                {getCardImageByType(cardType)}
              </ListItemAvatar>
            </ListItem>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <ListItem>
              <ListItemText
                primary="Saved Name"
                secondary={
                  <Typography variant="h6" color="secondary">
                    {nickName}
                  </Typography>
                }
              />
            </ListItem>
          </Grid>
        </Grid>
      </List>
    </Fragment>
  );
}
